export default "__VITE_ASSET__190d5141__"